import {
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalBroadcastService,
	MsalGuard,
	MsalService
} from "@azure/msal-angular";
import {
	MSALGuardConfigFactory,
	MSALInstanceFactory,
	MSALInterceptorConfigFactory
} from "../../app.module";

export const msalProviders = [
	{ provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
	{ provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
	{ provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
	MsalService,
	MsalGuard,
	MsalBroadcastService,
];
